<template>
  <div id="app">
    <!-- 全局头部 -->
    <Header />

    <!-- 主要内容区域 -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- 全局页脚 -->
    <Footer />

    <!-- 右侧悬浮导航 -->
    <FloatingNav />

    <!-- 全局隐私政策弹窗 -->
    <PrivacyDialog />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import FloatingNav from '@/components/FloatingNav.vue'
import PrivacyDialog from '@/components/PrivacyDialog.vue'

export default {
  name: 'App',

  components: {
    Header,
    Footer,
    FloatingNav,
    PrivacyDialog
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding-top: $header-height;

  @include mobile {
    padding-top: 64px;
  }
}
</style>
